module.exports = __webpack_public_path__ + "catalog/items/firesafety/fire-exit-right/fire-exit-right.svg";